module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shop-list"
  }, [_c('ul', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v(_vm._s(_vm.$t('Home')))])], 1), _c('li', {
    staticClass: "active"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Change Shop')))])])]), _c('div', {
    staticClass: "alert alert-info"
  }, [_c('i', {
    staticClass: "fa fa-info-circle"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('shop_list.message')))])]), (_vm.loading) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(0)]) : [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('shop_list.current_shop')) + "： " + _vm._s(_vm.currentShopName))])])]), _c('div', {
    staticClass: "row margin-top row-eq-height"
  }, _vm._l((_vm.shops), function(shop) {
    return _c('div', {
      staticClass: "col-sm-3 margin-top"
    }, [_c('a', {
      staticClass: "btn btn-block btn-default",
      class: {
        'btn-success': shop.id === null, 'btn-danger': shop.id === _vm.currentShopId
      },
      on: {
        "click": function($event) {
          _vm.setCurrentShopId(shop.id)
        }
      }
    }, [_vm._v(_vm._s(shop.attributes['shop-name']))])])
  }))]], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/loading.gif")
    }
  }), _c('p', [_vm._v("loading...")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-fcd549d0!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/shop-list.pug
// module id = 419
// module chunks = 1